import type { FormData } from "../types";
import type { ValidationErrors } from "./types";

export const DEFAULT_FORM_VALUES: FormData = {
  provider: "",
  priority: undefined,
  merchantId: "",
  mcc: undefined,
  isActive: true,
  type: "",
  merchantKey: "",
  credentials: {},
  brands: [],
};

export const DEFAULT_VALIDATION_ERRORS: ValidationErrors = {
  basicInfos: false,
  credentials: false,
  creditCardBrands: false,
};
